module.exports = __webpack_public_path__ + "img/conclusion1.e69dee09.png";